"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopperComponent = void 0;
var react_1 = require("react");
var jsx_runtime_1 = require("react/jsx-runtime");
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var material_1 = require("@mui/material");
var Autocomplete_1 = __importStar(require("@mui/material/Autocomplete"));
var omit_1 = __importDefault(require("lodash/omit"));
var throttle_1 = __importDefault(require("lodash/throttle"));
var react_2 = __importDefault(require("react"));
var AutocompleteButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/AutocompleteButton"));
var PopupText_1 = __importDefault(require("atomicComponents/molecules/Tooltips/PopupText"));
var AutocompletePopover_1 = __importDefault(require("../atoms/MultiSelect/AutocompletePopover"));
var AutocompleteWrapper_1 = __importDefault(require("../atoms/MultiSelect/AutocompleteWrapper"));
var MultiselectTextfield_1 = __importDefault(require("../atoms/MultiSelect/MultiselectTextfield"));
var OptionChip_1 = __importDefault(require("../atoms/MultiSelect/OptionChip"));
var Placeholder_1 = __importDefault(require("../atoms/MultiSelect/Placeholder"));
var PopperComponent = function (props) { return (0, jsx_runtime_1.jsx)(AutocompleteWrapper_1.default, __assign({}, (0, omit_1.default)(props, ['disablePortal', 'anchorEl', 'open']))); };
exports.PopperComponent = PopperComponent;
var MultiSelect = function (_a) {
    var _b;
    var _c = _a.input, name = _c.name, defaultValue = _c.value, onChange = _c.onChange, onBlur = _c.onBlur, restFormInputProps = __rest(_c, ["name", "value", "onChange", "onBlur"]), label = _a.label, options = _a.options, _d = _a.addOptions, addOptions = _d === void 0 ? true : _d, placeholder = _a.placeholder, _e = _a.isDisabled, isDisabled = _e === void 0 ? false : _e, btnProps = _a.btnProps, rest = __rest(_a, ["input", "label", "options", "addOptions", "placeholder", "isDisabled", "btnProps"]);
    var _f = __read(react_2.default.useState(null), 2), anchorEl = _f[0], setAnchorEl = _f[1];
    var _g = __read(react_2.default.useState(defaultValue || []), 2), values = _g[0], setValues = _g[1];
    var divRef = react_2.default.useRef(null);
    var handleClose = (0, throttle_1.default)(function () {
        if (anchorEl) {
            anchorEl.focus();
        }
        var newValues = onBlur === null || onBlur === void 0 ? void 0 : onBlur(values);
        if (newValues) {
            if (newValues instanceof Promise)
                newValues.then(function (nV) { return setValues(nV); });
            else
                setValues(newValues);
        }
        setAnchorEl(null);
    }, 500, { leading: true, trailing: false });
    var filter = (0, Autocomplete_1.createFilterOptions)();
    var filterOptions = function (opts, params) {
        var filtered = filter(opts, params);
        var inputValue = params.inputValue;
        // Suggest the creation of a new value
        var isExisting = opts === null || opts === void 0 ? void 0 : opts.some(function (option) { return inputValue === option.label; });
        if (inputValue !== '' && !isExisting && addOptions) {
            filtered.push({
                label: inputValue,
                value: inputValue,
                isNew: true,
            });
        }
        return filtered.filter(function (opt) { return !(values === null || values === void 0 ? void 0 : values.find(function (v) { return v.value === opt.value; })); });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, { ref: divRef, component: "span", mt: -7 }), (0, jsx_runtime_1.jsx)(AutocompleteButton_1.default, __assign({}, btnProps, { disabled: isDisabled, onClick: function () { return setAnchorEl(divRef.current); }, isPlaceholder: !(defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.length) }, { children: (0, jsx_runtime_1.jsx)(PopupText_1.default, { message: !(defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.length)
                        ? label
                        : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [defaultValue[0].label, (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.length) === 2 && " + ".concat((_b = defaultValue[1]) === null || _b === void 0 ? void 0 : _b.label), (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.length) > 2 && " + ".concat(defaultValue.length - 1, " more")] })) }) })), (0, jsx_runtime_1.jsx)(AutocompletePopover_1.default, __assign({ open: !!anchorEl, anchorEl: anchorEl, onClose: handleClose }, { children: (0, jsx_runtime_1.jsx)(Autocomplete_1.default, __assign({}, rest, { onBlur: handleClose, open: true, multiple: true, options: options, disableCloseOnSelect: true, disableClearable: true, filterSelectedOptions: true, forcePopupIcon: false, disabled: isDisabled, getOptionDisabled: function () { return isDisabled || false; }, filterOptions: filterOptions, getOptionLabel: function (option) { return "".concat(option.isNew ? 'Create ' : '').concat(option.label); }, PopperComponent: exports.PopperComponent, value: values, renderTags: function (tag, getTagProps) { return tag.map(function (option, index) { return ((0, react_1.createElement)(OptionChip_1.default, __assign({ variant: "outlined", label: option.label }, getTagProps({ index: index }), { key: option.value, deleteIcon: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }))); }); }, renderInput: function (inputProps) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(MultiselectTextfield_1.default, __assign({}, inputProps, restFormInputProps, { name: name })), (0, jsx_runtime_1.jsx)(Placeholder_1.default, { children: placeholder })] })); }, onChange: function (event, newValue) {
                        setValues(newValue || []);
                        if (onChange)
                            onChange(newValue || []);
                    } })) }))] }));
};
exports.default = MultiSelect;
